/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 12.04.13
 * Time: 15:16
 */

import { Constants_Offer } from "../Constants_Offer";
import { OfferDescriptionDictionary } from "../OfferDescriptionDictionary";
import { IOfferDescriptionRewardParameter } from "./rewards/IOfferDescriptionRewardParameter";
import { IPrivateOfferModel } from "../offerQuestConditions/IPrivateOfferModel";
import { IOfferDescription } from "./IOfferDescription";

/**
 * Defines a offer reward container
 */
export class OfferDescriptionRewards implements IOfferDescription {
    private _rewards: Map<any, any>;
    private _model: IPrivateOfferModel;

    constructor(dataModel: IPrivateOfferModel) {
        this._model = dataModel;
    }

    public get name(): string {
        return Constants_Offer.REWARD_COMPONENT_CONTAINER;
    }

    public registerOfferDescription(dictonary: OfferDescriptionDictionary): void {
        dictonary.addEntry(this.name, this);
    }

    public parseFromObjectParam(params: Object): void {
        this.parseListOfRewards(params);
    }

    public toString(): string {
        let text: string = "Reward Descriptions";
        for (let key of Array.from(this._rewards.keys())) {
            let value: IOfferDescriptionRewardParameter = this._rewards.get(key);
            text += "\n   " + key + " --> " + value;
        }
        return text;
    }

    /**
     * Dictionary of all reward elements
     */
    public get rewards(): Map<any, any> {
        return this._rewards;
    }

    protected parseListOfRewards(params: any): void {
        this._rewards = new Map<any, any>();

        for (let i: number = 0; i < params.length; ++i) {
            this._rewards.set(params[i].name, this._model.createOfferDescriptionRewardObject(params[i].name, params[i].params));
        }
    }

    public dispose(): void {
        if (this._rewards) {
            for (let object of Array.from(this._rewards.values())) {
                if (typeof (object.dispose) === "function") {
                    ((<IOfferDescriptionRewardParameter>object)).dispose();
                }
            }

            this._rewards = null;
        }

        this._model = null;
    }
}
